<template>
    <div>
        <table class="table table-responsive-sm table-valign-middle mb-0">
            <tbody>
            <tr v-for="p of plans" :key="p.id">
                <td>
                    <div class="d-flex align-items-center"><i class="radio-select mr-2" @click="select(p)"
                                                              :class="{'radio-select-selected': selected(p)}"></i>{{
                        p.nickname }}
                    </div>
                </td>
                <td>
                    <button class="btn btn-default" v-if="hasFeatures(p)" @click="showFeatures(p)">Features</button>
                </td>
                <td class="text-capitalize">
                    <template v-if="tiered(p)"><strong class="table-plan-price mr-1" v-if="tier(p)">{{ (tier(p).amount /
                        100) | currency }}</strong><strong class="table-plan-price mr-1" v-if="!tier(p)">Starts with {{
                        (p.tiers[0].amount / 100) | currency }}</strong>/ Location / {{ p.interval |
                        interval(p.interval_count) }}
                    </template>
                    <template
                            v-if="perUnit(p)"><strong class="table-plan-price mr-1">Fixed {{ (p.amount / 100) | currency
                        }}</strong>/ Location / {{ p.interval | interval(p.interval_count) }}
                    </template>
                </td>
                <td class="text-right"></td>
            </tr>
            </tbody>
        </table>
        <choose-locations-limit :plan="stripePlan" :value="locationsLimit" @input="updateLocationsLimit"
                                v-if="tiered(stripePlan)"></choose-locations-limit>
        <modal ref="features" size="sm" effect="none"><span slot="title">{{ planName }}</span>
            <ul class="plan-feature-list p-0 m-0">
                <li v-for="feature of features" :key="feature">{{ feature }}</li>
            </ul>
            <div slot="footer">
                <button class="btn btn-default" @click="$refs.features.close()">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            plans: {required: true, type: Array},
            planId: {required: true},
            locationsLimit: {required: true}
        },

        data: () => ({
            planName: null,
            features: []
        }),

        computed: {
            stripePlan() {
                return this.plans.find(plan => plan.id === this.planId);
            }
        },

        methods: {
            select(plan) {
                this.updatePlanId(plan.id);
                this.updateLocationsLimitAccordingTo(plan);
            },

            updateLocationsLimitAccordingTo(plan) {
                if (this.perUnit(plan)) {
                    this.updateLocationsLimit(null);
                }
                if (this.tiered(plan) && !this.locationsLimitExistsIn(plan)) {
                    this.updateLocationsLimit(plan.tiers[0].up_to);
                }
            },

            locationsLimitExistsIn(plan) {
                return plan.tiers && plan.tiers.filter(t => t.up_to).map(t => t.up_to).includes(this.locationsLimit);
            },

            selected(plan) {
                return this.planId === plan.id;
            },

            tiered(plan) {
                return plan && plan.billing_scheme === 'tiered';
            },

            hasFeatures(plan) {
                return Object.keys(plan.metadata).length;
            },

            showFeatures(plan) {
                this.$refs.features.open();
                this.planName = plan.name || plan.nickname;
                this.features = Object.keys(plan.metadata);
            },

            tier(plan) {
                if (!plan || !this.tiered(plan)) return null;
                return (
                    plan.tiers.find(t => t.up_to === this.locationsLimit) || null
                );
            },

            perUnit(plan) {
                return plan.billing_scheme === 'per_unit';
            },

            updatePlanId(planId) {
                this.$emit('update:planId', planId);
            },

            updateLocationsLimit(limit) {
                this.$emit('update:locationsLimit', limit);
            }
        }
    };
</script>
